import { IoScaleOutline } from "react-icons/io5";
import { useParams } from "react-router-dom";
import useSetSidebar from "effects/useSidebar";
import Capabilities from "lib/constants/Capabilities";
import { useSelector } from "store";
import { selectStorageByID, selectCaseScannerByID } from "store/reducers";
import { Restrict } from "components/Restricted";
import { Header } from "components/Typography";
import { MenuItem } from "components/sidebars/MenuItem/MenuItem";
import Sidebar, { MenuSeparator } from "components/sidebars/Sidebar";
import { SidebarImage } from "components/sidebars/SidebarImage/SidebarImage";
import style from "./sidebar.module.scss";

export const CaseScannerSidebar = () => {
  useSetSidebar(true);
  const { caseScannerID } = useParams();
  const url = `/apps/storage/case_scanners/${caseScannerID}`;
  const entity = useSelector(selectCaseScannerByID(caseScannerID || ""));
  const storage = useSelector(selectStorageByID(entity?.storageId || ""));
  return (
    <Sidebar>
      {entity && (
        <div className={style.sidebarImageHeader}>
          {entity.imageUrl && <SidebarImage imageUrl={entity.imageUrl} />}
          <Header>{storage?.name}</Header>
        </div>
      )}
      <MenuSeparator />
      <MenuItem to={`${url}/usage`} icon={<IoScaleOutline />}>
        Usage history
      </MenuItem>
      <Restrict capability={Capabilities.STORAGE_UPDATE}>
        <MenuItem to={`${url}/access_control`} icon="/images/icons/identity.svg">
          Manage access
        </MenuItem>
      </Restrict>
      <Restrict capability={Capabilities.STORAGE_UPDATE}>
        <MenuSeparator />
        <MenuItem to={`${url}/alerts`} icon="/images/icons/alert_2.svg">
          Alerts
        </MenuItem>
        <MenuItem to={`${url}/settings`} icon="/images/icons/config_2.svg">
          Settings
        </MenuItem>
      </Restrict>
    </Sidebar>
  );
};
